"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const ITEMS = [
  { key: "home", baseHref: "/mobile", label: "Start", icon: "🏠" },
  { key: "scan", baseHref: "/invoices/inbox", label: "Scan", icon: "📷" },
  { key: "journal", baseHref: "/finance/journal", label: "Journal", icon: "📒" },
  { key: "vat", baseHref: "/finance/vat", label: "MWST", icon: "🧾" }
] as const;

export default function MobileBottomNav() {
  const pathname = usePathname();
  const parts = (pathname || "").split("/").filter(Boolean);
  const mandateSlug = parts[0] === "m" && parts[1] ? parts[1] : null;
  const mandateQuery = mandateSlug ? `?companySlug=${encodeURIComponent(mandateSlug)}` : "";

  return (
    <nav className="mobile-bottom-nav" aria-label="Mobile Navigation">
      {ITEMS.map((item) => {
        const href = item.key === "home" && mandateSlug ? `/m/${encodeURIComponent(mandateSlug)}` : `${item.baseHref}${mandateQuery}`;
        const active = pathname === item.baseHref || pathname?.startsWith(`${item.baseHref}/`) || (item.key === "home" && Boolean(mandateSlug) && pathname === `/m/${mandateSlug}`);
        return (
          <Link
            key={item.key}
            href={href}
            className={`mobile-nav-link ${active ? "is-active" : ""}`}
          >
            <span aria-hidden="true">{item.icon}</span>
            <span>{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
